import { observer } from "mobx-react"
import React from "react"
import AIModalJson from "../../Configs/JSON/AIModal.json"
import FormStore from "../../Configs/Store/forms"
import "../../styles/calculator/AnnualIncomeModal.less"
import CircleIcon from "../Common/CircleIcon"
import GenericModal from "../Common/GenericModal"

const AI_Modal = observer(() => {
  return (
    <>
      <GenericModal
        visibleState={FormStore.calc_aiModal}
        updateVisibility={() => FormStore.setAIModal(false)}
        closeIcon={
          <CircleIcon iconUrl={"common/Iconionic-md-close-circle-outline"} />
        }
        rootClassAntCustom={"AnnualIncomeModal"}
        showButton={true}
        buttonText={AIModalJson["buttonText"]}
        // buttonStyle={"OKButton"}
        buttonWrapper={"calculateFormDiv"}
        buttononClick={() => FormStore.setAIModal(false)}
        component={
          <div className="contentWrap">
            <CircleIcon
              iconStyle="titleICon"
              iconUrl={AIModalJson["mainIcon"]}
            />
            <div className="SectionTitle">{AIModalJson["modalTitle"]}</div>
            <div className="content">{AIModalJson["modalContent"]}</div>
          </div>
        }
      />
    </>
  )
})

export default AI_Modal
